require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-locations-masaya-aeromundo.json") })
        }
      }, "path---en-locations-masaya-aeromundo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-locations-masaya-aeromundo!./.cache/json/en-locations-masaya-aeromundo.json
// module id = 1056
// module chunks = 231608221292675